"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var const_1 = require("./const");
var prosemirror_tables_1 = require("prosemirror-tables");
var isInList = function ($pos) { return $pos.parent.type.name === 'list_item'; };
var createCellAttrs = function (defaultColWidth, extraAttrs) {
    if (extraAttrs === void 0) { extraAttrs = {}; }
    var attrs = {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: [defaultColWidth]
        }
    };
    Object.keys(extraAttrs).forEach(function (key) {
        attrs[key] = { default: extraAttrs[key].default };
    });
    return attrs;
};
exports.createCellAttrs = createCellAttrs;
var getCellAttrs = function (dom, extraAttrs) {
    if (extraAttrs === void 0) { extraAttrs = {}; }
    var widthAttr = dom.getAttribute('data-colwidth');
    var widths = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(',').map(function (s) { return Number(s); }) : null;
    var colspan = Number(dom.getAttribute('colspan') || 1);
    var result = {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: widths && widths.length === colspan ? widths : null
    };
    Object.keys(extraAttrs).forEach(function (prop) {
        var getter = extraAttrs[prop].getFromDOM;
        var value = getter && getter(dom);
        if (value !== null)
            result[prop] = value;
    });
    return result;
};
exports.getCellAttrs = getCellAttrs;
var setCellAttrs = function (node, extraAttrs) {
    if (extraAttrs === void 0) { extraAttrs = {}; }
    var attrs = {};
    if (node.attrs.colspan !== 1)
        attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1)
        attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth)
        attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    Object.keys(extraAttrs).forEach(function (prop) {
        var setter = extraAttrs[prop].setDOMAttr;
        if (setter)
            setter(node.attrs[prop], attrs);
    });
    return attrs;
};
exports.setCellAttrs = setCellAttrs;
var createRow = function (type, _column, config) {
    var content = [];
    var col = _column;
    // 在表格中自定义当前 cell 的宽度
    var attrs = type === const_1.NODE_NAME.TABLE_CELL ? { colwidth: [config.cellWidth] } : undefined;
    while (col--) {
        content.push({ type: type, attrs: attrs, content: [{ type: 'paragraph' }] });
    }
    return {
        type: const_1.NODE_NAME.TABLE_ROW,
        content: content
    };
};
var createTableNode = function (_row, column, config) {
    if (!_row || !column)
        return null;
    var row = _row;
    var content = [];
    if (config.useTableHeader) {
        content.push(createRow(const_1.NODE_NAME.TABLE_HEADER, column, config));
        row--;
    }
    while (row--) {
        content.push(createRow(const_1.NODE_NAME.TABLE_CELL, column, config));
    }
    return { type: const_1.NODE_NAME.TABLE, content: content };
};
exports.createTableNode = createTableNode;
var closestNode = function ($pos, nodeNames) {
    var depth = $pos.depth;
    var _loop_1 = function () {
        var node = $pos.node(depth);
        if (nodeNames.some(function (name) { return name === node.type.name; })) {
            return { value: { node: node, from: $pos.before(depth), to: $pos.after(depth) } };
        }
        depth--;
    };
    while (depth > 0) {
        var state_1 = _loop_1();
        if (typeof state_1 === "object")
            return state_1.value;
    }
};
var closestCell = function ($pos) { return closestNode($pos, [const_1.NODE_NAME.TABLE_CELL, const_1.NODE_NAME.TABLE_HEADER]); };
exports.closestCell = closestCell;
var closestTable = function ($pos) { return closestNode($pos, [const_1.NODE_NAME.TABLE]); };
exports.closestTable = closestTable;
var goToCell = function (state, dispatch, dir) {
    if (dir === void 0) { dir = 1; }
    var $from = state.selection.$from;
    var tableInfo = closestTable($from);
    if (!tableInfo)
        return false;
    var table = tableInfo.node;
    if (isInList($from))
        return false;
    var cellInfo = closestCell($from);
    if (!cellInfo)
        return false;
    var cell = cellInfo.node;
    if (dir === -1 && table.firstChild && cell === table.firstChild.firstChild)
        return true;
    else if (dir === 1 && table.lastChild && cell === table.lastChild.lastChild)
        return true;
    return prosemirror_tables_1.goToNextCell(dir)(state, dispatch);
};
exports.goToCell = goToCell;
/**
 * 获取表格中单元格的总数
 * @param node
 */
var getTableLength = function (node) {
    if (node.type.name === 'table') {
        var rowLength = node.childCount;
        var colLength = (node.firstChild && node.firstChild.childCount) || 0;
        return rowLength * colLength;
    }
    return 0;
};
/**
 * 判断表格是否全选
 * @param view
 */
var judgeSelectAllTable = function (view) {
    try {
        var _a = view.state.selection, ranges = _a.ranges, $head = _a.$head;
        var tableNode = $head.node(1);
        return ranges.length === getTableLength(tableNode);
    }
    catch (e) {
        return false;
    }
};
exports.judgeSelectAllTable = judgeSelectAllTable;
//# sourceMappingURL=utils.js.map